import { z } from 'zod';
import { MoneySchema } from './common.js';
// NOTE: `common.ts` already exports `CurrencyCodeSchema` as a closed z.enum of
// known codes. The Currency MASTER row schema below is exported as
// `CurrencyMasterSchema` to avoid the barrel collision. The `code` field uses a
// generic 3-letter ISO-4217 pattern (not the closed enum) because the master
// table is the source of truth and may legitimately contain codes not yet in
// the common enum.
export const CurrencyMasterSchema = z.object({
    id: z.uuid(),
    code: z
        .string()
        .length(3)
        .regex(/^[A-Z]{3}$/),
    nameTh: z.string().min(1),
    symbol: z.string().min(1),
    // Prisma Decimal(18,6) — exchange rate to THB; base currency rate is 1.
    rate: z.union([MoneySchema, z.coerce.number().nonnegative()]),
    isBase: z.boolean(),
    // ISO datetime string on the wire; service converts to Date for Prisma.
    lastUpdate: z.iso.datetime(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateCurrencyMasterSchema = CurrencyMasterSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
// Currencies are global (no companyId), and `code` is the natural key — so it
// is also immutable at update time. Only rates and display fields can change.
export const UpdateCurrencyMasterSchema = CreateCurrencyMasterSchema.partial().omit({
    code: true,
});
//# sourceMappingURL=currency.js.map